import React, { useEffect, useState } from "react";
import { Button, Input, TimePicker } from "antd";
import { SuccessToast } from "../../../widgets/AppToast";
import { useNavigate } from "react-router-dom";
import { post } from "../../../services/services";
import { ApiURL } from "../../../services/apiConstants";
import VoyageDetails from "../../../components/VoyageDetails";
import AppInput from "../../../components/AppInput";
import dayjs from "dayjs";

function AddBunkerReport() {
  const navigate = useNavigate();
  const [staff_dashboard, set_staff_dashboard] = useState([]);
  const [loader, set_loader] = useState(false);
  const [inputValues, setInputValues] = useState({});
  const [subTankList, setSubTankList] = useState([]);
  const [submitStatus, setSubmitStatus] = useState(false);
  const [date, set_Date] = useState(null);
  const [time, set_Time] = useState("");
  const [place, set_Place] = useState("");
  const [trim, set_Trim] = useState("");
  const [previous_log_date, set_Previous_Log_Date] = useState("");
  const [tankDetails, setTankDetails] = useState(null);

  const LIST_SUB_TANKS_API = async () => {
    try {
      const FORM_DATA = new FormData();
      const staff_Details = JSON.parse(localStorage.getItem("user_data"));
      FORM_DATA.append("ship_id", staff_Details?.data?.ship_details?.ship_id);
      post(ApiURL?.bunker_report_list, FORM_DATA).then((res) => {
        if (res?.status == true) {
          setSubTankList(res?.tanks);
          set_Previous_Log_Date(res?.last_date);
        }
      });
    } catch (error) {
      console.error("Error fetching Sub Tanks list:", error);
    }
  };

  useEffect(() => {
    if (tankDetails?.tanks_level_details?.length > 0) {
      const formatted = tankDetails.tanks_level_details.reduce((acc, tank) => {
        acc[tank.id] = {
          ullage: tank.ullage_cm || "",
          volume: tank.QTTY ? Number(tank.QTTY) : 0,
          density: tank.Density ? Number(tank.Density) : 0,
          temperature: tank.TK_Temp ? Number(tank.TK_Temp) : 15,
          sulphur: tank.sulphur || "",
          rob: tank.rob ? Number(tank.rob) : 0,
        };
        return acc;
      }, {});

      setInputValues(formatted);
    }
  }, [tankDetails]);

  const GET_TANKS_LEVEL_DETAILS = async () => {
    try {
      const FORM_DATA = new FormData();
      const res = await post(ApiURL.tanks_level_details_st, FORM_DATA);
      if (res?.status === true) {
        setTankDetails(res.data);
        set_Time(res.data.time ? dayjs(res.data.time, "HH:mm") : null);
        set_Date(res.data?.date || "");
        set_Place(res.data?.place || "");
        set_Trim(res.data?.trim || "");
      } else {
        setTankDetails({ tanks_level_details: [] });
      }
    } catch (error) {
      console.log("Error message *****", error);
      setTankDetails({ tanks_level_details: [] });
    }
  };

  const handleInputChange = (tankId, value, key) => {
    setInputValues((prev) => {
      let updatedTank = {
        ...prev[tankId],
        [key]: value,
      };

      const volume = parseFloat(updatedTank?.volume);
      const density = parseFloat(updatedTank?.density);
      const temp = parseFloat(updatedTank?.temperature);

      if (!isNaN(volume) && !isNaN(density) && !isNaN(temp)) {
        const rob = (volume * density * (1 - 0.00065 * (temp - 15))).toFixed(2);
        updatedTank.rob = rob;
      } else {
        updatedTank.rob = "";
      }

      return {
        ...prev,
        [tankId]: updatedTank,
      };
    });
  };

  const handleTimeChange = (time) => {
    set_Time(time);
  };

  const handlePlaceChange = (e) => {
    set_Place(e.target.value);
  };
  const handleTrimChange = (e) => {
    set_Trim(e.target.value);
  };

  function findNestedObjects(obj) {
    let nestedObjects = [];

    for (let tankId in obj) {
      if (
        obj.hasOwnProperty(tankId) &&
        typeof obj[tankId] === "object" &&
        obj[tankId] !== null
      ) {
        const tankData = { tank_id: tankId };
        let hasData = false;

        for (let key in obj[tankId]) {
          const value = obj[tankId][key];
          if (value !== "" && value !== null && value !== undefined) {
            tankData[key] = value;
            hasData = true;
          }
        }

        if (hasData) {
          // Enrich with metadata
          const tankMeta = subTankList.find(
            (tank) => tank.id === parseInt(tankId)
          );
          if (tankMeta) {
            tankData.capacity = tankMeta.capacity;
            tankData.grade = tankMeta.fuel_type;
            tankData.tank_name = tankMeta.category_name || "Unknown";
          }

          nestedObjects.push(tankData);
        }
      }
    }

    return nestedObjects;
  }

  const ADD_LEVEL_API = async () => {
    set_loader(true);
    const nestedArray = findNestedObjects(inputValues);
    try {
      const FORM_DATA = new FormData();
      const staff_Details = JSON.parse(localStorage.getItem("user_data"));
      FORM_DATA.append("ship_id", staff_Details?.data?.ship_details?.ship_id);
      FORM_DATA.append("voyage_id", staff_dashboard?.voyage_details?.[0]?.id);
      FORM_DATA.append("place", place);
      FORM_DATA.append("log_date", date);
      FORM_DATA.append("log_time", time ? time.format("HH:mm") : "");

      FORM_DATA.append("trim", trim);
      FORM_DATA.append("tank_data", JSON.stringify(nestedArray));

      post(ApiURL.add_bunker_report, FORM_DATA).then((res) => {
        if (res?.status == true) {
          SuccessToast(
            "Add Sub Tanks Level Success!",
            "Adding Sub Tank Level details have been successfully"
          );
          navigate("/list-bunker-record");
          set_loader(false);
          LIST_SUB_TANKS_API();
          setSubmitStatus(res?.updated_tanks?.submit_status);
        } else {
          set_loader(false);
        }
      });
    } catch (error) {
      set_loader(false);
      console.error("Error Tanks Lebel:", error);
    }
  };

  useEffect(() => {
    const staff_dashboards = localStorage.getItem("staff_dashboard");
    const parsedData = JSON.parse(staff_dashboards);
    set_staff_dashboard(parsedData);
    LIST_SUB_TANKS_API();
    GET_TANKS_LEVEL_DETAILS();
  }, []);

  const tableStyle = {
    width: "100%",
    borderCollapse: "collapse",
    marginTop: "20px",
  };

  const tableHeaderStyle = {
    border: "1px solid #ddd",
    padding: "8px",
    backgroundColor: "#f4f4f4",
    fontWeight: "bold",
    textAlign: "center",
  };

  const tableCellStyle = {
    border: "1px solid #ddd",
    padding: "7px",
    textAlign: "center",
  };

  // Group tanks by fuel type
  const groupedTanks = subTankList.reduce((acc, tank) => {
    const fuelType = tank.fuel_type || "Unknown Fuel Type"; // Handle cases where fuel_type is missing
    if (!acc[fuelType]) {
      acc[fuelType] = [];
    }
    acc[fuelType].push(tank);
    return acc;
  }, {});

  return (
    <>
      <VoyageDetails staff_dashboard={staff_dashboard?.voyage_details} />
      <div className="white-container">
        <h3>Bunker Record Information</h3>
        <div>
          <div style={{ display: "flex", gap: "20px", marginTop: "15px" }}>
            <div style={{ flex: 1 }}>
              <b>Date</b>
              <br />
              <AppInput
                type="date"
                placeholder="Date"
                value={date}
                onChange={(e) => set_Date(e.target.value)}
                min={previous_log_date}
                max={new Date().toISOString().split("T")[0]}
              />
            </div>
            <div style={{ flex: 1 }}>
              <b>Time</b>
              <br />
              <TimePicker
                style={{ width: "100%" }}
                onChange={handleTimeChange}
                value={time}
                format="HH:mm"
              />
            </div>
            <div style={{ flex: 1 }}>
              <b>Place</b>
              <Input value={place} onChange={handlePlaceChange} />
            </div>
            <div style={{ flex: 1 }}>
              <b>Trim</b>
              <Input value={trim} onChange={handleTrimChange} />
            </div>
          </div>

          {Object.entries(groupedTanks).map(([fuelType, tanks]) => (
            <div style={{ marginTop: "10px" }} key={fuelType}>
              <h4>Fuel Type: {fuelType}</h4>
              <table style={tableStyle}>
                <thead>
                  <tr>
                    <th style={tableHeaderStyle}>SL No</th>
                    <th style={tableHeaderStyle}>Tank Name</th>
                    <th style={tableHeaderStyle}>Grade </th>
                    <th style={tableHeaderStyle}>Capacity (m3)</th>
                    <th style={tableHeaderStyle}>ullage cm/sounding cm</th>
                    <th style={tableHeaderStyle}>QTTY (m3)</th>
                    <th style={tableHeaderStyle}>Density @ 15 deg</th>
                    <th style={tableHeaderStyle}>TK Temp (Deg C)</th>
                    <th style={tableHeaderStyle}>Sulphur %</th>
                    <th style={tableHeaderStyle}>QTTY (MT)</th>
                  </tr>
                </thead>
                <tbody>
                  {tanks?.map((item) => (
                    <tr key={item?.id}>
                      <td style={tableCellStyle}>{item?.id}</td>
                      <td style={tableCellStyle}>
                        {item?.category_name || "Fuel Oil Tank"}
                      </td>
                      <td style={tableCellStyle}>{item?.fuel_type}</td>
                      <td style={tableCellStyle}>{item?.capacity}</td>
                      <td style={tableCellStyle}>
                        <Input
                          placeholder="ullage cm"
                          value={inputValues[item?.id]?.ullage || ""}
                          onChange={(e) =>
                            handleInputChange(item.id, e.target.value, "ullage")
                          }
                        />
                      </td>
                      <td style={tableCellStyle}>
                        <Input
                          placeholder="Volume E (m3)"
                          value={inputValues[item?.id]?.volume || ""}
                          onChange={(e) =>
                            handleInputChange(item.id, e.target.value, "volume")
                          }
                        />
                      </td>
                      <td style={tableCellStyle}>
                        <Input
                          placeholder="Density @ 15 deg"
                          value={inputValues[item?.id]?.density || ""}
                          onChange={(e) =>
                            handleInputChange(
                              item.id,
                              e.target.value,
                              "density"
                            )
                          }
                        />
                      </td>
                      <td style={tableCellStyle}>
                        <Input
                          placeholder="TK Temp (Deg C)"
                          value={inputValues[item?.id]?.temperature || ""}
                          onChange={(e) =>
                            handleInputChange(
                              item.id,
                              e.target.value,
                              "temperature"
                            )
                          }
                        />
                      </td>
                      <td style={tableCellStyle}>
                        <Input
                          placeholder="Sulphur %"
                          value={inputValues[item?.id]?.sulphur || ""}
                          onChange={(e) =>
                            handleInputChange(
                              item.id,
                              e.target.value,
                              "sulphur"
                            )
                          }
                        />
                      </td>

                      <td style={tableCellStyle}>
                        <Input
                          placeholder="ROB quantity (MT)"
                          style={{ textAlign: "center" }}
                          disabled
                          value={inputValues[item?.id]?.rob || ""}
                          onChange={(e) =>
                            handleInputChange(item.id, e.target.value, "rob")
                          }
                        />
                      </td>
                    </tr>
                  ))}
                  {/* Totals Row */}
                  <tr>
                    <td style={tableCellStyle} colSpan="5">
                      <b>Total</b>
                    </td>

                    <td style={tableCellStyle}>
                      {/* Calculate and display total ROB for this fuel type */}
                      {tanks
                        ?.reduce((total, tank) => {
                          const rob =
                            parseFloat(inputValues[tank.id]?.volume) || 0;
                          return total + rob;
                        }, 0)
                        .toFixed(1)}
                    </td>

                    <td style={tableCellStyle}>
                      <b></b>
                    </td>
                    <td style={tableCellStyle}>
                      <b></b>
                    </td>
                    <td style={tableCellStyle}>
                      <b></b>
                    </td>
                    <td style={tableCellStyle}>
                      {/* Calculate and display total ROB for this fuel type */}
                      {tanks
                        ?.reduce((total, tank) => {
                          const rob =
                            parseFloat(inputValues[tank.id]?.rob) || 0;
                          return total + rob;
                        }, 0)
                        .toFixed(1)}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          ))}

          <div className="row">
            <div className="input-box" style={{ marginTop: "15px" }}>
              <Button
                loading={loader}
                disabled={submitStatus}
                type="primary"
                className="save_btn"
                style={{ color: "white", marginLeft: "10px" }}
                onClick={() => ADD_LEVEL_API()}
              >
                Save
              </Button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default AddBunkerReport;
